import styled from 'styled-components';

export const TitleContent = styled.div`
  background-color: #F0F6FE;
  padding: 64px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({paddingContent}) => `${paddingContent} 0` };
  @media screen and (max-width: 959px) {
    padding-top: 24px;
    padding-bottom: 40px;
  }
  h1 {
    font-size: 39px;
    @media screen and (max-width: 959px) {
      font-size: 27px;
    }
  }

  h3 {
    padding-top: 24px;
    font-size: 23px;
    @media screen and (max-width: 959px) {
      padding-top: 16px;
      font-size: 13px;
    }
  }
`;

